// Bloque dominante "Requieren atención". Orden ALTA -> MEDIA -> urgencia. Responsable = el que
// declara la vista (Central Galarya en residencial/real; personal del centro en institucional).
import { useEffect, useRef } from "react";
import { Activity, ArrowUpRight } from "lucide-react";
import { acentoPri } from "@/lib/centroV3/data";

function Fila({ a, highlight, onAbrirCaso }) {
  const ac = acentoPri(a.prioridad);
  const sinTomar = a.estado === "sin_tomar";
  const ref = useRef(null);
  useEffect(() => { if (highlight && ref.current) ref.current.scrollIntoView({ behavior: "smooth", block: "nearest" }); }, [highlight]);
  return (
    <div ref={ref} data-testid={`centro-atencion-${a.id}`} className={`flex flex-col gap-2 rounded-lg border-l-[5px] bg-white px-3 py-2 shadow-sm transition-shadow sm:flex-row sm:items-center sm:justify-between sm:gap-3 ${highlight ? "ring-2 ring-[#01CBE3] ring-offset-1" : ""}`} style={{ borderLeftColor: ac.hex }}>
      <div className="flex items-center gap-2.5 min-w-0">
        <Activity strokeWidth={1.9} className="h-5 w-5 shrink-0" style={{ color: ac.hex }} />
        <div className="min-w-0">
          <div className="flex items-center gap-2">
            <p className="text-sm font-extrabold uppercase tracking-tight text-[#012472]">{a.verbo}</p>
            <span className="rounded px-1.5 py-0.5 text-[10px] font-bold text-white" style={{ backgroundColor: ac.hex }}>{a.prioridad.toUpperCase()}</span>
          </div>
          <p className="truncate text-sm font-bold text-slate-800">{a.persona}</p>
          {a.room && <p className="truncate text-xs text-slate-500">{a.room}</p>}
          {a.tecnicaMarca && <span className="mt-0.5 inline-flex items-center gap-1 rounded bg-[#9B2C2C]/10 px-1.5 py-0.5 text-[11px] font-medium text-[#9B2C2C]">{a.tecnicaMarca}</span>}
        </div>
      </div>
      <div className="flex flex-wrap items-center gap-3 shrink-0">
        <p className="font-mono tabular-nums text-base font-bold" style={{ color: ac.hex }}>{a.hace}</p>
        {sinTomar ? (
          <span className="rounded px-2 py-0.5 text-[11px] font-bold" style={{ backgroundColor: `${ac.hex}22`, color: ac.hex }}>Pendiente</span>
        ) : (
          <div className="text-right">
            <span className="inline-block rounded bg-[#01CBE3]/15 px-2 py-0.5 text-[11px] font-bold text-[#0891A6]">En atención · {a.responsable || "Central Galarya"}</span>
            {a.operador && <p className="text-[11px] text-slate-400">{a.operador}</p>}
          </div>
        )}
        {/* v2.14.0 — el recorrido operativo abre ESTE caso en Central (deep-link existente). */}
        {onAbrirCaso && (
          <button data-testid={`centro-atencion-central-${a.id}`} type="button"
            onClick={() => onAbrirCaso({ alarma_id: a.id })}
            className="inline-flex min-h-9 items-center gap-1 rounded-lg bg-[#012472] px-2.5 text-xs font-bold text-white transition-colors hover:bg-[#012472]/90 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#01CBE3]">
            Ir a Central <ArrowUpRight className="h-3.5 w-3.5" />
          </button>
        )}
      </div>
    </div>
  );
}

export default function AtencionList({ atencion, onAbrirCentral, onAbrirCaso, highlightNombre }) {
  const orden = [...atencion].sort((x, y) => (x.prioridad === "alta" ? 0 : x.prioridad === "media" ? 1 : 2) - (y.prioridad === "alta" ? 0 : y.prioridad === "media" ? 1 : 2));
  return (
    <section data-testid="centro-requieren-atencion" className="rounded-2xl border border-[#FE6A55]/30 bg-[#FE6A55]/[0.06] p-3.5">
      <div className="mb-2.5 flex items-center justify-between">
        <h2 className="text-sm font-extrabold uppercase tracking-wider text-[#012472]">Atención del centro</h2>
        {onAbrirCentral && <button data-testid="centro-abrir-central" onClick={onAbrirCentral} className="inline-flex items-center gap-1 text-xs font-semibold text-[#0891A6] hover:underline">Ir a Central de Monitoreo <ArrowUpRight className="h-3.5 w-3.5" /></button>}
      </div>
      <div className="space-y-2">
        {orden.map((a) => <Fila key={a.id} a={a} onAbrirCaso={onAbrirCaso} highlight={!!highlightNombre && a.persona === highlightNombre} />)}
      </div>
    </section>
  );
}
